// extracted by mini-css-extract-plugin
export default {"countBlock":"CountBlock_countBlock__7zCMN","disabled":"CountBlock_disabled__1DDWl"};